import { render } from "./SpoofCreate.vue?vue&type=template&id=5a6b3308"
import script from "./SpoofCreate.vue?vue&type=script&lang=js"
export * from "./SpoofCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__